module.exports = __webpack_public_path__ + "ticket.ab651164.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/ticket.png
// module id = 484
// module chunks = 0